export {StaticContext, match, withRouter, RouteProps, RouteComponentProps} from 'react-router'
export {Redirect, Route, Link, Switch} from 'react-router-dom'
export {History, Location, LocationState} from 'history'
import {withSentryRouting} from '@sentry/react'
import { Route } from 'react-router-dom';
const SentryRoute = withSentryRouting(Route);

export { SentryRoute }

// export interface RouteComponentProps<Params extends { [K in keyof Params]?: string } = {}, C extends StaticContext = StaticContext, S = LocationState> {
// 	history?: History;
// 	location?: Location<S>;
// 	match?: match<Params>;
// 	staticContext?: C;
// }



// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/react-router.ts